import { Reducer } from "../../../lib/redux";
import { HosDisplayPreferencesActions } from "./actions";
import { HosDisplayPreferencesActionTypes, IHosDisplayPreferences } from "./types";

export const defaultHosDisplayPreferences: IHosDisplayPreferences = {};

export const hosDisplayPreferences: Reducer<IHosDisplayPreferences, HosDisplayPreferencesActions> = (
    state = defaultHosDisplayPreferences,
    action
) => {
    switch (action.type) {
        case HosDisplayPreferencesActionTypes.SET_SPLIT_SLEEPER_ENABLED: {
            const { userId, enabled } = action.payload;
            if (!userId) {
                return state;
            }
            return {
                ...state,
                [userId]: {
                    splitSleeperEnabled: enabled
                }
            };
        }
        case HosDisplayPreferencesActionTypes.CLEAR_SPLIT_SLEEPER_PREFERENCE: {
            const userId = action.payload;
            if (!userId || !state[userId]) {
                return state;
            }
            const { [userId]: removedPreference, ...remainingPreferences } = state;
            return remainingPreferences;
        }
        default:
            return state;
    }
};
